
/*
 * @Author: Qzx
 * @Date: 2020-04-04 14:41:45
 * @Description: 项目公共函数
 * @LastEditors: wangxin
 * @LastEditTime: 2020-05-24 14:42:02
 */
const _ua = navigator.userAgent
// const ua = navigator.userAgent.toLowerCase()
/**
 * 判断是否在App内
 */
export function isApp () {
  return /jzh$/i.test(_ua)
}

// export const browser = {
//   weixin: ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i).indexOf('micromessenger') > -1,
//   android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
//   ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
//   yach: u.indexOf('Yach') > -1 || u.indexOf('yach') > -1
// }
export const browser = {
  isApp: isApp(),
  weixin: /MicroMessenger/i.test(_ua),
  android: /(Android)|(Adr)/i.test(_ua),
  ios: /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(_ua),
  yach: /yach/i.test(_ua)
}
/**
 * url添加query
 * @param params: {a:1, b:2, name: 'myName'}
 * @returns {string}
 */
export const addQuery = function (params) {
  let str = ''
  let url = window.location.href
  const hash = window.location.hash
  const query = {}
  url.replace(/[?&]+([^=&]+)=([^&#]*)/gi, function (m, key, value) {
    query[key] = value
  })
  // console.log('url', url, query)
  for (const key in params) {
    // 防止原有search部分与新添加的冲突
    if (query[key]) {
      // 如果原来已存在key值，则会被覆盖
      url = url.replace(`${key}=${query[key]}`, `${key}=${params[key]}`)
    } else {
      str += `&${key}=${params[key]}`
    }
  }
  // console.log('str', str)
  if (/\?/.test(hash)) {
    url += str
  } else {
    url += str.replace('&', '?')
  }
  return url
}
/**
 * 获取url参数的值
 * @param {*} url 通常为window.location.href
 * @return {Object} params  参数数组
 */
export function getUrlParmas (url) {
  const vars = {}
  url.replace(/[?&]+([^=&]+)=([^&#]*)/gi, function (m, key, value) {
    vars[key] = value
  })
  return vars
}
/**
 * 获取服务端时间
 */
export function getNowTime () {
  return new Promise(resolve => {
    const xhr = new window.XMLHttpRequest()
    xhr.responseType = 'document'
    const url = addQuery({ xestime: +new Date() }) // 给url添加时间戳
    // 通过get的方式请求当前文件
    xhr.open('head', url)
    xhr.send(null)
    // 监听请求状态变化
    xhr.onreadystatechange = function () {
      let time = null
      if (xhr.readyState === 2) {
        // 获取响应头里的时间戳
        time = xhr.getResponseHeader('Date')
        console.log('serve time', time)
        time = time ? new Date(time) : new Date()
        console.log('time', time)
        const debug = parseInt(getUrlParmas(location.href).xesdebugtime)
        if (isNaN(debug) || debug < 0 || debug > 253402272000000) {
          resolve(time)
        } else {
          resolve(new Date(debug))
        }
      }
    }

    setTimeout(function () {
      resolve(new Date())
    }, 2000)
  })
}
/**
 * 格式化日期
 * date: 符合 new Date(date) 的日期格式
 */
export function dateFormat (fmt, date) {
  if (!date) return
  date = date.replace(/-/g, '/')
  const dateObj = new Date(date)
  let ret
  const opt = {
    'Y+': dateObj.getFullYear().toString(), // 年
    'm+': (dateObj.getMonth() + 1).toString(), // 月
    'd+': dateObj.getDate().toString(), // 日
    'H+': dateObj.getHours().toString(), // 时
    'M+': dateObj.getMinutes().toString(), // 分
    'S+': dateObj.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    }
  }
  return fmt
}
/**
 * 根据时间差获取时分秒
 * @param {endTime} endTime
 * @param {tiem} time
 */
export function resolveTimeDiff (endTime, time) {
  const timediff = Math.round((endTime.getTime() - time.getTime()) / 1000)
  // console.log('resolveTimeDiff', timediff)
  const day = parseInt(timediff / 3600 / 24)
  const hour = parseInt(timediff / 3600 % 24)
  const minute = parseInt(timediff / 60 % 60)
  const second = parseInt(timediff % 60)
  return {
    day, // 获取还剩多少天
    hour: hour.toString().padStart(2, 0), // 获取还剩多少小时
    minute: minute.toString().padStart(2, 0), // 获取还剩多少分钟
    second: second.toString().padStart(2, 0) // 获取还剩多少秒
  }
}
/**
 *
 * @returns 是否在微信小程序中
 */
export function isMiniprogram () {
  return new Promise((resolve) => {
    if (!browser.weixin) {
      resolve(false)
    } else {
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          resolve(true)
        } else {
          resolve(false)
        }
        console.log('isMini', res)
      })
    }
  })
}
